import { Component, Inject, Input, Output, EventEmitter } from "@angular/core";
import { combineLatest, forkJoin, Observable, of, Subject } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { SubjectRelay } from "../../../../shared/commands/subject-relay.class";
import { MatTableDataSource } from "@angular/material/table";

import { EntrepriseExterieureEntity } from "../../entities/entreprise-exterieure.entity";
import { EntrepriseTLR } from "../../../entreprises/entities/entreprise-tlr.entity";
import { UpdateStepEntrepriseOrder } from "../../entities/document-pa-update-step-entreprise-order.entity";
import { SignatairePaEntity } from "../../entities/signataire-pa.entity";
import { IntervenantService } from "../../../humain/intervenant/services/intervenant.service";
import { EntrepriseService } from "../../../entreprises/services/entreprise.service";
import { IntervenantTLR } from "../../../humain/intervenant/entities/intervenant-tlr.entity";
import { DocumentPersonneAvertieResult } from "../../entities/document-personne-avertie-result";
import { UpdateStepValidationOrder } from "../../entities/document-pa-update-step-validation-order.entity";

import { DocumentPaService } from "../../services/document-pa-service";

@Component({
    selector: 'pa-manage-intervenants',
    templateUrl: 'pa-manage-intervenants.html',
    styleUrls: ['pa-manage-intervenants.css'],
})
export class PaManageIntervenantComponent {
    displaySubject = new Subject<boolean>();
    euEeData?: UpdateStepEntrepriseOrder;
    currentPaInstance!: DocumentPersonneAvertieResult;

    @Input() id = 'paIntervenantsDialog';

    private intervenantCommandsSubject = new SubjectRelay<number>();

    @Input()
    set intervenantCommands(obs: Observable<number> | undefined) {
        this.intervenantCommandsSubject.registerSource(obs);
    }

    entreprises: EntrepriseTLR[] = [];
    intervenantsEe: IntervenantTLR[] = [];

    entrepriseUtilisatrice!: EntrepriseTLR;

    selectedEntrepriseForIntervenantDialog!: EntrepriseTLR | null;

    personnesPouvantSigner: SignatairePaEntity[] = [];
    signataires: MatTableDataSource<SignatairePaEntity> = new MatTableDataSource<SignatairePaEntity>();
    gererIntervenantsCommands = new Subject<[SignatairePaEntity[], SignatairePaEntity[]]>();

    displayedColumnsSignataires: string[] = ['nom', 'prenom'];

    private currentPa$ = new SubjectRelay<DocumentPersonneAvertieResult>();
    entreprisesExterieures: Map<number, EntrepriseExterieureEntity> = new Map<number, EntrepriseExterieureEntity>();
    eeIsIntervenant: boolean = false;

    constructor(
        @Inject(IntervenantService) intervenantService: IntervenantService,
        @Inject(EntrepriseService) entrepriseService: EntrepriseService,
        @Inject(DocumentPaService) private documentPaService: DocumentPaService
    ) {

        this.intervenantCommandsSubject.subscribe((currentPaId) => {
            if (currentPaId) {


                const euEeData$ = this.documentPaService.getStepEntrepriseData(currentPaId);
                let intervenants$ = intervenantService.getIntervenantsTLRList();
                let entreprises$ = entrepriseService.getActiveEntreprisesTLRList();
                let stepData$ = this.documentPaService.getValidationData(currentPaId);
				
				this.currentPaInstance = new DocumentPersonneAvertieResult();
				this.currentPaInstance.id = currentPaId;

                // let signataires$ = // FIXME step data ;

                const data$ = combineLatest([euEeData$, stepData$, entreprises$, intervenants$]).pipe(
                    mergeMap(([euEeData, stepData, allEntreprises, allIntervenants]) =>
                        forkJoin({
                            euEeData: of(euEeData),
                            stepData: of(stepData),
                            allEntreprises: of(allEntreprises),
                            allIntervenants: of(allIntervenants),
                        })
                    )
                );

                data$.subscribe(({ euEeData, stepData, allEntreprises, allIntervenants }) => {
                    this.euEeData = euEeData;

                    if (stepData?.signataires?.length) {

                        const enrichedSignataires =
                            this.findhSignatairesWithEntreprise(
                                stepData.signataires,
                                allIntervenants,
                                allEntreprises
                            );

                        this.signataires = new MatTableDataSource<SignatairePaEntity>(
                            enrichedSignataires
                        );

                        if (this.euEeData?.idResponsableEe) {
                            this.eeIsIntervenant = enrichedSignataires.some(
                                s => s.id === this.euEeData!.idResponsableEe
                            );
                        }

                    } else {
                        this.signataires = new MatTableDataSource<SignatairePaEntity>([]);
                        this.eeIsIntervenant = false;
                    }


                    if (this.euEeData) {
	                    this.entreprises = [];
	                    this.intervenantsEe = [];
	
	                    const entreprise = allEntreprises.find(ent => ent.id === this.euEeData?.idEntrepriseEe);
	                    if (entreprise) {
	                        this.entreprises.push(entreprise);
	                    }
	
	                    this.intervenantsEe = allIntervenants.filter(intervenant => intervenant.entrepriseId === this.euEeData?.idEntrepriseEe);
	
	                    this.displaySubject.next(true);
					}

                });
            }
        });

    }

    openDialogIntervenants = () => {
        let filteredSignataire: SignatairePaEntity[] = [];
        const selected = this.getSelectedSignataireKeys();

        const mapAndFilter = (intervenants: IntervenantTLR[], entreprise: EntrepriseTLR) =>
            intervenants
                .filter(i =>
                    !selected.some(
                        s =>
                            s.id === i.id &&
                            s.nature === 'intervenant' &&
                            s.idEntreprise === entreprise.id
                    )
                )
                .map(i => this.mapIntervenantToSignataire(i, entreprise));


        if (!this.selectedEntrepriseForIntervenantDialog) {
            const eeEntreprise = this.entreprises.find(e => e.id === this.euEeData?.idEntrepriseEe);

            if (eeEntreprise) {
                filteredSignataire.push(...mapAndFilter(this.intervenantsEe, eeEntreprise));
            }
        } else {
            const entreprise = this.selectedEntrepriseForIntervenantDialog;

            if (entreprise.id === this.euEeData?.idEntrepriseEe) {
                filteredSignataire = mapAndFilter(this.intervenantsEe, entreprise);
            }
        }
        filteredSignataire = filteredSignataire.filter($ => this.signataires.data.map(s => s.id).indexOf($.id) < 0);
        // Remove EE responsable from LEFT when checkbox is checked
        if (this.eeIsIntervenant && this.euEeData?.idResponsableEe) {
            filteredSignataire = filteredSignataire.filter(
                s => s.id !== this.euEeData!.idResponsableEe
            );
        }

        this.gererIntervenantsCommands.next([
            filteredSignataire.sort((a, b) => a.nom.localeCompare(b.nom)),
            this.signataires.data.sort((a, b) => a.nom.localeCompare(b.nom))
        ]);
    };

    private mapIntervenantToSignataire(
        intervenant: IntervenantTLR,
        entreprise: EntrepriseTLR
    ): SignatairePaEntity {
        return {
            id: intervenant.id,
            nom: intervenant.nom,
            prenom: intervenant.prenom ?? '',

            idEntreprise: entreprise.id,
            nomEntreprise: entreprise.nom,
            raisonSociale: entreprise.nom,

            fonction: intervenant.cadreEmploi ?? '',
            email: intervenant.email ?? '',

            hasSigned: false,
            hasSignedEnvelope: false,
            sentToDocusign: false,
            emailStyle: '',
            envelopeId: '',
            envelopeIndex: -1,

            nature: 'intervenant',
            isIntervenant: true,
            updatable: false,
            docusignRecipientId: ''
        };
    }

    private getSelectedSignataireKeys() {
        return this.signataires.data.map(s => ({
            id: s.id,
            nature: s.nature,
            idEntreprise: s.idEntreprise
        }));
    }

    onIntervenantsSelected(data: [SignatairePaEntity[], SignatairePaEntity[]]) {
        let intervenantsLies = data[1];
        let newSource: SignatairePaEntity[] = [];
        if (intervenantsLies !== undefined) {
            intervenantsLies.forEach((value: SignatairePaEntity) => newSource.push(value));
        }
        this.signataires = new MatTableDataSource<SignatairePaEntity>(newSource);

        if (this.euEeData?.idResponsableEe) {
            this.eeIsIntervenant = newSource.some(
                s => s.id === this.euEeData!.idResponsableEe
            );
        }
    }

    private buildEeResponsableSignataire(): SignatairePaEntity {
        if (!this.euEeData) {
            throw new Error('EU/EE data not loaded');
        }

        const eeEntreprise = this.entreprises.find(
            e => e.id === this.euEeData!.idEntrepriseEe
        );

        return {
            id: this.euEeData.idResponsableEe!,
            nom: this.euEeData.nomPrenomResponsableEe?.split(' ')?.[0] ?? '',
            prenom: this.euEeData.nomPrenomResponsableEe?.split(' ')?.slice(1).join(' ') ?? '',

            idEntreprise: eeEntreprise?.id ?? -1,
            nomEntreprise: eeEntreprise?.nom ?? '',
            raisonSociale: eeEntreprise?.nom ?? '',

            email: this.euEeData.emailResponsableEe ?? '',
            fonction: this.euEeData.fonctionResponsableEe ?? '',

            hasSigned: false,
            hasSignedEnvelope: false,
            sentToDocusign: false,
            emailStyle: '',
            envelopeId: '',
            envelopeIndex: -1,

            nature: 'ee',
            isIntervenant: true,
            updatable: false,
            docusignRecipientId: ''
        };
    }

    eeIsIntervenantChange(): void {
        if (!this.euEeData?.idResponsableEe) {
            return;
        }

        let current = [...this.signataires.data];
        const eeId = this.euEeData.idResponsableEe;

        if (this.eeIsIntervenant) {
            if (!current.some(s => s.id === eeId)) {
                current.push(this.buildEeResponsableSignataire());
            }
        } else {
            current = current.filter(s => s.id !== eeId);
        }

        this.signataires = new MatTableDataSource(current);
    }

    private findhSignatairesWithEntreprise(
        signataires: SignatairePaEntity[],
        allIntervenants: IntervenantTLR[],
        allEntreprises: EntrepriseTLR[]
    ): SignatairePaEntity[] {

        return signataires.map(signataire => {
            const intervenant = allIntervenants.find(i => i.id === signataire.id);

            if (!intervenant) {
                return signataire;
            }

            const entreprise = allEntreprises.find(
                e => e.id === intervenant.entrepriseId
            );

            if (!entreprise) {
                return signataire;
            }

            return {
                ...signataire,
                idEntreprise: entreprise.id,
                nomEntreprise: entreprise.nom,
                raisonSociale: entreprise.nom
            };
        });
    }

    onCloseRequested() {
        this.displaySubject.next(false);
    }

    getSignatairesByEntreprise(): Map<number, SignatairePaEntity[]> {
        const map = new Map<number, SignatairePaEntity[]>();

        this.signataires.data.forEach(signataire => {
            if (!map.has(signataire.idEntreprise)) {
                map.set(signataire.idEntreprise, []);
            }
            map.get(signataire.idEntreprise)!.push(signataire);
        });

        return map;
    }

    saveIntervenants(): void {
        if (!this.currentPaInstance?.id) {
            console.error('PA id manquant, sauvegarde impossible');
            return;
        }

        const payload = this.buildUpdateSignatairesPayload();

        this.documentPaService.updateValidationStep(payload).subscribe({
            next: () => {
                this.displaySubject.next(false);
            },
            error: err => {
                console.error(
                    'Erreur lors de la sauvegarde des intervenants',
                    err
                );
            }
        });
    }

    private buildUpdateSignatairesPayload(): UpdateStepValidationOrder {
        const payload = new UpdateStepValidationOrder();

        payload.id = this.currentPaInstance.id;

		payload.signataires = this.signataires.data.map(s => ({
		    id: s.id,
		    email: s.email,
		    fonction: s.fonction
		} as SignatairePaEntity)); 

        return payload;
    }
}